/**
 * Same-origin stylesheet rules currently applied in the app (Tailwind, etc.).
 * Cross-origin sheets are skipped (cssRules throws).
 */
const collectAccessibleStylesheetsCss = (): string => {
  let css = '';
  for (const sheet of Array.from(document.styleSheets)) {
    try {
      for (const rule of Array.from(sheet.cssRules)) {
        css += `${rule.cssText}\n`;
      }
    } catch {
      // Cross-origin or inaccessible stylesheet
    }
  }
  return css;
};

/**
 * The web portal hides certificates off-screen (`fixed left-[-200vw]`) and
 * constrains `.certificate-page` only inside `@media print`. For native we
 * need those rules to apply unconditionally so the HTML renders at the correct
 * 11 × 8.5 in landscape size without off-screen positioning.
 */
const NATIVE_PRINT_STYLES = `
  @page {
    size: landscape;
    margin: 0;
  }
  #printable-certificates {
    display: block !important;
    position: static !important;
    left: auto !important;
    width: 100% !important;
  }
  .certificate-page {
    page-break-after: always;
    page-break-inside: avoid;
    break-after: page;
    break-inside: avoid;
    width: 11in;
    height: 8.5in;
    overflow: hidden;
    box-sizing: border-box;
  }
  .certificate-page:last-child {
    page-break-after: auto;
    break-after: auto;
  }
`;

/**
 * Serialises the live `#printable-certificates` DOM together with all app CSS
 * and native-specific overrides so the fragment renders correctly outside the
 * web print flow.
 */
export const serializeCertificatePrintDomForNative = (): string | null => {
  const root = document.getElementById('printable-certificates');
  if (!root) {
    return null;
  }

  const appCss = collectAccessibleStylesheetsCss();

  return `<style>${appCss}</style><style>${NATIVE_PRINT_STYLES}</style>${root.outerHTML}`;
};
